// Dependencies
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";

// Components
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";
import {Dialog} from "../../../../utils/Dialog/Dialog.component";
import {Subsidiary} from "../../../halls/types/subsidiaries";

//Actions
import {ActionCreator} from "../../../../actions/actions";
import {SpecialPrizesPresetsActionCreators} from "../../actions/actionCreators";

//Store
import {specialPrizesPresetsStoreSelectors} from "../../store/store";

//Utils
import Paginator from "../../../../utils/Paginator/Paginator.component";
import {checkPermission} from "../../../../utils/Authorization/authorization";
import {formatDateText} from "../../../../utils/utils";


// Constants
const PRESETS_PER_PAGE = 21;
const INITIAL_PAGE = 0;

export interface PresetsListProps extends RouteComponentProps {
    getSubsidiaries: ActionCreator;
    subsidiariesList: Subsidiary[];
    subsidiariesLoading: boolean;
    getPresets: ActionCreator;
    presetsList: {
        presets: any[];
        timestamp: string;
        count: number;
    };
    presetsLoading: boolean;
    certifiedPreset: ActionCreator;
    activatePreset: ActionCreator;
    deactivatePreset: ActionCreator;
}

export interface PresetsListState {
    currentPage: number;
    searchText: string;
    subsidiaryFilterValue: string[];
    typeFilterValue: string[];
    statusFilterValue: string;
    certifiedFilterValue: string;
    showConfirmPreset: boolean;
    showConfirmPresetId: number;
    showConfirmPresetValue: boolean;
}

const JACKPOTS_KEYS = {
    5: "Pig Boom",
    6: "Mr. Champion"
};

class PresetsList extends Component<PresetsListProps, PresetsListState> {
    subsidiaryFilter: React.RefObject<Components.SelectMenu>;
    typeFilter: React.RefObject<Components.SelectMenu>;
    clearFilters: boolean;

    constructor(props) {
        super(props);

        this.props.getSubsidiaries();

        this.subsidiaryFilter = React.createRef();
        this.typeFilter = React.createRef();

        this.state = {
            currentPage: INITIAL_PAGE,
            searchText: "",
            subsidiaryFilterValue: [],
            typeFilterValue: [],
            statusFilterValue: "1",
            certifiedFilterValue: "",
            showConfirmPreset: false,
            showConfirmPresetId: 0,
            showConfirmPresetValue: false
        };

        this.getPresets()
        this.clearFilters = false

    }

    getPresets = (subsidiaries = null, types = null) => {
        this.props.getPresets({
            page: this.state.currentPage,
            top: PRESETS_PER_PAGE,
            search: this.state.searchText,
            subsidiaries: subsidiaries ? subsidiaries : this.state.subsidiaryFilterValue,
            types: types ? types : this.state.typeFilterValue,
            status: this.state.statusFilterValue,
            certified: this.state.certifiedFilterValue
        });
    }

    applyFilters = (value, field) => {
        if (!this.clearFilters) {
            let updatedState = {...this.state};
            updatedState[field] = value
            this.setState({
                ...updatedState,
                currentPage: INITIAL_PAGE
            }, this.getPresets)
        }
    }

    pageChange = newPage => {
        this.setState({currentPage: newPage - 1}, this.getPresets);
    };

    onClearFilters = () => {
        this.clearFilters = true

        this.subsidiaryFilter.current.selectItem([]);
        this.subsidiaryFilter.current.setDisplayString("Choose Subsidiary");

        this.typeFilter.current.selectItem([]);
        this.typeFilter.current.setDisplayString("Choose Types");

        this.setState({
            searchText: "",
            subsidiaryFilterValue: [],
            typeFilterValue: [],
            statusFilterValue: "1",
            certifiedFilterValue: ""
        }, this.getPresets);

        this.clearFilters = false
    };

    certifiedPreset = () => {
        this.props.certifiedPreset(this.state.showConfirmPresetId, !this.state.showConfirmPresetValue);
        this.setState({
            showConfirmPreset: false,
            showConfirmPresetId: 0,
            showConfirmPresetValue: false
        })
    };

    exportData = (data) => {
        const link = document.createElement("a");
        link.href = `data:text/json;chatset=utf-8,${encodeURIComponent(
            JSON.stringify(data)
        )}`;
        link.download = data.name + ".json";
        link.click();
    };

    renderFilters = () => {
        const presetStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "Active"
            },
            {
                value: 0,
                label: "Inactive"
            }
        ];

        const typeItems = [
            {
                label: "Pig Boom",
                value: "5"
            },
            {
                label: "Mr. Champion",
                value: "6"
            }
        ];

        const presetCertified = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "Certified"
            },
            {
                value: 0,
                label: "Not Certified"
            }
        ];

        return (
            <div className="row">
                <div className="col-12">
                    <div className="presets-filters">
                        <div id="PresetsPageFiltersBox">
                            <div className="row">
                                {this.props.subsidiariesLoading && (
                                    <div className="presets-list-loading">
                                        <Components.LoadingRipple
                                            width={"75px"}
                                            height={"75px"}
                                        />
                                    </div>
                                )}
                                {!this.props.subsidiariesLoading && (
                                    <div className="adjustable-filters">
                                        <div className="preset-filter">
                                            <label className="label">
                                                Search
                                            </label>
                                            <input
                                                className="input"
                                                onChange={event => this.applyFilters(event.target.value, 'searchText')}
                                                value={this.state.searchText}
                                                placeholder="Text"
                                            />
                                        </div>
                                        <div className="preset-filter">
                                            <label className="label">
                                                Subsidiaries
                                            </label>
                                            <Components.SelectMenu
                                                key={`${this.state.subsidiaryFilterValue}`}
                                                ref={this.subsidiaryFilter}
                                                noValueLabel="Choose Subsidiary"
                                                multipleSelection
                                                items={
                                                    this.props.subsidiariesList &&
                                                    this.props.subsidiariesList.length > 0
                                                        ? SubsidiaryUtils.subsidiarySelectItems(
                                                            this.props.subsidiariesList
                                                        )
                                                        : []
                                                }
                                                onChange={event => this.applyFilters(event, 'subsidiaryFilterValue')}
                                                value={this.state.subsidiaryFilterValue}
                                            />
                                        </div>
                                        <div className="preset-filter">
                                            <label className="label">
                                                Type
                                            </label>
                                            <Components.SelectMenu
                                                ref={this.typeFilter}
                                                noValueLabel="Choose Types"
                                                items={typeItems}
                                                onChange={event => this.applyFilters(event, 'typeFilterValue')}
                                                value={
                                                    this.state.typeFilterValue
                                                        ? this.state.typeFilterValue[0]
                                                        : ""
                                                }
                                            />
                                        </div>
                                        <div className="adjustable-filters">
                                            <div className="preset-filter">
                                                <label className="label">
                                                    Status
                                                </label>
                                                <Components.CheckboxGroup
                                                    key={this.state.statusFilterValue}
                                                    items={presetStatus}
                                                    selected={this.state.statusFilterValue}
                                                    onChange={event => this.applyFilters(event, 'statusFilterValue')}
                                                />
                                            </div>
                                        </div>
                                        <div className="preset-filter">
                                            <label className="label">
                                                Certified
                                            </label>
                                            <Components.CheckboxGroup
                                                key={this.state.certifiedFilterValue}
                                                items={presetCertified}
                                                selected={this.state.certifiedFilterValue}
                                                onChange={event => this.applyFilters(event, 'certifiedFilterValue')}
                                            />
                                        </div>
                                        <div>
                                            <button
                                                className="clear-filters-btn"
                                                onClick={this.onClearFilters}
                                            >
                                                Clear All Filters
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderPresets = () => {
        if (this.props.presetsList.presets && this.props.presetsList.presets.length === 0) {
            return (
                <div className="preset-list-no-preset">
                    No Special Prizes Presets records to display. Please select different
                    values to try again.
                </div>
            );
        }
        return (this.props.presetsList.presets &&
            this.props.presetsList.presets.map((preset, index) => {
                const sub = this.props.subsidiariesList.find(
                    subsidiary => subsidiary.id == preset.subsidiary
                );
                return (
                    <div className="preset-card" key={index}>
                        <div className="preset-card-body">
                            <div className="preset-card-btns">
                                {checkPermission("certified_prog_presets") && (
                                    <span
                                        className="btn tooltip-icon"
                                        onClick={() => {
                                            this.setState({
                                                showConfirmPreset: true,
                                                showConfirmPresetId: preset.id,
                                                showConfirmPresetValue: preset.certified
                                            })
                                        }}
                                    >
                                        <span
                                            className="tooltip-text">{preset.certified ? "Uncertify " : "Certify"}</span>
                                        <i className={`icon-file-text ${preset.certified && "green"}`}></i>
                                    </span>
                                )}
                                {checkPermission("add_prog_presets") && (
                                    <Link
                                        className="btn tooltip-icon"
                                        to={`/admin/special-prizes-presets/edit/${preset.id}/`}
                                    >
                                        <span className="tooltip-text">Clone</span>
                                        <i className="icon-clone-light"></i>
                                    </Link>
                                )}
                                {checkPermission("add_prog_presets") && (
                                    <div>
                                        <button
                                            className="btn tooltip-icon"
                                            onClick={()=> this.exportData(preset)}
                                        >
                                            <span className="tooltip-text">Download</span>
                                            <i className="icon-arrow-to-bottom-light" />

                                        </button>
                                    </div>
                                )}
                            </div>
                            <h2>{preset.name}</h2>
                            <p className="icon_info">
                                <i className={`icon-file-text ${preset.certified && "green"}`}/>
                                {preset.certified ? "Certified" : "Not Certified"}
                            </p>
                            <label>Id: {preset.id}</label>
                            <label>Type Applicable</label>
                            <p>{JACKPOTS_KEYS[preset.type]}</p>
                            <label>Subsidiary</label>
                            {sub && (
                                <div className="subsidiary">
                                    {SubsidiaryUtils.subsidiaryIcon(sub)}
                                    {sub.description}
                                </div>
                            )}
                            {sub == undefined && "-"}
                            <label>Creation Date</label>
                            <p>
                                {formatDateText(
                                    preset.creation_date, "short", true, true, true
                                )}
                            </p>
                        </div>
                        <div className="preset-card-footer">
                            <a
                                className="preset-card-link"
                                href={`/admin/special-prizes-presets/detail/${preset.id}/`}
                            >
                                Details
                            </a>

                            {checkPermission("toggle_prog_presets") && (
                                <div className="preset-card-status">
                                    <span>
                                        {preset.active ? "Active" : "Inactive"}
                                    </span>
                                    <Components.Switch
                                        onClick={() =>
                                            preset.active
                                                ? this.props.deactivatePreset(preset.id)
                                                : this.props.activatePreset(preset.id)
                                        }
                                        on={preset.active}
                                        enabled={
                                            !(preset.default == true)
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                )
            })
        )
    }

    render() {
        const isLoading = this.props.subsidiariesLoading || this.props.presetsLoading;
        return (
            <div id="PresetsList" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2>Special Prizes Presets</h2>
                        </div>
                        <div className="col-6 center-vertical buttons-col">
                            {checkPermission("add_prog_presets") && (
                                <Link
                                    to={`/admin/special-prizes-presets/new`}
                                    className="new-preset red-btn"
                                >
                                    <span>New Special Prize Preset</span>
                                </Link>
                            )}
                        </div>
                    </div>
                    {this.renderFilters()}
                    <div className="presets-list">
                        {isLoading ? (
                            <div className="presets-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="presets row">
                                {this.renderPresets()}
                            </div>
                        )}
                    </div>
                </div>
                {!isLoading && (
                    <div className="row presets-pagination container">
                        <div className="col-6 center-vertical last-update">
                            <p>{`Last update: ${this.props.presetsList.timestamp}`}</p>
                        </div>

                        <div className="col-6 center-vertical paginator">
                            {this.props.presetsList.presets &&
                                this.props.presetsList.count > 0 && (
                                    <Paginator
                                        currentPage={this.state.currentPage + 1}
                                        totalPages={Math.ceil(
                                            this.props.presetsList.count /
                                            PRESETS_PER_PAGE
                                        )}
                                        onPageChange={this.pageChange}
                                    />
                                )}
                        </div>
                    </div>
                )}
                <Dialog
                    open={this.state.showConfirmPreset}
                    onConfirm={this.certifiedPreset}
                    onClose={() => {
                        this.setState({
                            showConfirmPreset: false,
                            showConfirmPresetId: 0,
                            showConfirmPresetValue: false
                        })
                    }}
                >
                    Are you sure you want to change the certified status for this preset?
                </Dialog>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    subsidiariesList: specialPrizesPresetsStoreSelectors.subsidiariesList(state),
    subsidiariesLoading: specialPrizesPresetsStoreSelectors.subsidiariesLoading(state),
    presetsList: specialPrizesPresetsStoreSelectors.presetsList(state),
    presetsLoading: specialPrizesPresetsStoreSelectors.presetsLoading(state)
});

const mapDispatchToProps = {
    getSubsidiaries: SpecialPrizesPresetsActionCreators.getSubsidiaries,
    getPresets: SpecialPrizesPresetsActionCreators.getPresets,
    certifiedPreset: SpecialPrizesPresetsActionCreators.certifiedPreset,
    deactivatePreset: SpecialPrizesPresetsActionCreators.deactivatePreset,
    activatePreset: SpecialPrizesPresetsActionCreators.activatePreset,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PresetsList));
